module.exports = __webpack_public_path__ + "static/media/shallot.a87b91aa.jpg";